module.exports = "/_next/static/images/6135cb8886196531522e3cbe8dd69315-about-us-hero-desktop.jpg.webp";